export const environment = {
    production: true,
    backend: 'https://controladorexterno.uv.cl/webpay',
    sentry: {
        dns: 'https://689e3170225a46ca80e6ecb13ce4b0d9@o560748.ingest.sentry.io/4505172431142912',
        tracingOrigins: ['https://pagos.uv.cl'],
    },
    analytics: 'G-TWLTQEZ6CK',
};
